module.exports = __webpack_public_path__ + "img/20.a9221479.jpg";